module.exports = __webpack_public_path__ + "static/media/check-w.d4390266.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/svg/check-w.svg
// module id = 1036
// module chunks = 0